<template>
    <footer class="footer">
        <div class="container text-center"><a class="link" href="tel:191"><span class="link__icon svg-icon" aria-hidden="true">
            <svg role="img" width="24" height="24" fill="#fff" aria-hidden="true">
              <use xlink:href="#svg-icon-phone2"></use>
            </svg></span><span class="link__text">{{ $t("contactCenter") }}</span></a>
        </div>
    </footer>
</template>
<script>
export default {
    
}
</script>
<style scoped>
.link__text{
    color:#fff;
}
</style>